<template> 
    <div class="cadre">   
         
        <div>
            <transition-group class="tree" name="list" tag="ul">                            
                <li class="menu-brique list" v-for="folder in filtrerFolder(arborescence, documentFolderId)" :key="folder.id">
                    <div v-if="rafraichir">
                        document importé avec succès
                    </div>                                
                    <a v-bind:class="(etendreTab[folder.id] === true) ? 'a' : 'a '" v-on:click="sendEtendre(folder.id,documentFolderId )" >
                        <div>
                            <i v-bind:class="(etendreTab[folder.id] === true) ? 'far fa-folder-open' : 'far fa-folder-close'"></i>
                            {{folder.lib}}
                        </div>                             
                        <div class="status-badge" v-bind:class="(folder.document_folder_statut == 'INC') ? 'badge-incomplete':(folder.document_folder_statut == 'CAV') ? 'badge-pending':'badge-complete'">
                            {{afficherStatut(folder)}}
                        </div>
                    </a>                   
                    <div v-show="etendreTab[folder.id] === true" class="folder-content-wrapper">                                             
                        <div class="folder-content">              
                            <div v-if="folderFilsExiste(folder.id) ">
                                <ArborescenceFolder 
                                    :arborescence="filtrerFolderRec(arborescence,folder.id)" 
                                    :documentFolderId="parseInt(folder.id)" 
                                    :listeDocument="listeDocument"
                                    :etendreTab="etendreTab">
                                </ArborescenceFolder>       
                            </div> 
                            <div v-if="afficherListe==folder.id">               
                                <ListeDocument                   
                                    :listeDocument ="filtrerDocument(listeDocument,folder.id)"
                                    :titreFolder="folder.lib" 
                                    :folderId="parseInt(folder.id)">                                           
                                </ListeDocument> 
                            </div>       
                        </div>
                    </div>                                            
                </li>
            </transition-group>
        </div>
        <div v-if="(documentFolderId == 0 && listeDocument)">
            <ListeDocument
                :listeDocument="filtrerDocument(listeDocument,documentFolderId)"
                :titreFolder="'A la racine'"
                :folderId="0">
            </ListeDocument>
        </div>
    </div>
</template>
    
<script>
    import ListeDocument from './ListeDocument.vue';      
    export default {
        name: "ArborescenceFolder",
        components: { ListeDocument },
        props: {
            arborescence: Array,
            documentFolderId: Number,
            listeDocument: Object,
            etendreTab: Object,
                 
        },
        data(){
            return {
                listeFolderAlaRacine:[], 
                afficherListe:0, 
                rafraichir:false      
            }
        },
        created() {
            this.$root.$on('gestionFermeture',(folderId) =>{      
                this.arborescence.forEach(element => {
                    if (element.document_folder == folderId) {
                        if(this.etendreTab[element.id] === null || this.etendreTab[element.id] === true){
                            this.etendreTab[element.id] = false          
                        }
                        this.gestionFermeture(element.id)
                    }
                })              
            }),
            this.$root.$on('gestionFermetureListe',(folderId) =>{      
                this.afficherListe = folderId                  
            })
            this.$root.$on('afficherDocument',(document) =>{     
                this.rafraichir=true  
                setTimeout(() => {}, "1000")
                this.rafraichir=false    
            })     
        },  
        methods: {
            //methode pour obtenir la liste des sous-folder du folder courant 
            filtrerFolder(arr,folderId) {
                let arboresTrie = []
                    arr.forEach(element => {
                        if (element.document_folder == folderId) {
                            arboresTrie.push(element);
                        }           
                    });
                
                return arboresTrie;
            },
            filtrerFolderRec(arr,folderId) { 
                let arboresTrie = []
                    arr.forEach(element => {
                        if (element.document_folder == folderId) {
                            arboresTrie.push(element);
                            if(this.folderFilsExiste(element.id)){
                                let arboresTrieBis = this.filtrerFolderRec(this.arborescence,element.id)
                                arboresTrieBis.forEach(element=>{
                                    arboresTrie.push(element)
                                })
                            }
                        }          
                    });
                return arboresTrie       
            },
            //methode pour obtenir la liste des id  folders se situant à la racine de l'arborescence courant
            filtrerFolderALaRacine(documentFolderId){
                this.listeFolderAlaRacine = []
                this.arborescence.forEach(element => {
                    if (element.document_folder == documentFolderId) {
                        this.listeFolderAlaRacine.push(element.id);
                    }
                })
                return this.listeFolderAlaRacine

            },
            //methode qui renvoie true si un element est dans une liste
            estDansLaListe(arr,folderId){
                let i = 0
                while(i < arr.length && !(arr[i] == folderId)){
                    i ++
                }
                if(i < arr.length){
                    return true
                }
                return false
            },
            //methode pour pour obtenir la liste des documents du folder courant
            filtrerDocument(arr, folderId) {
                let listeDocTrie
                listeDocTrie = arr[folderId];
                return listeDocTrie;
            },
            //methode pour la gestion de fermeture du folder courant ainsi que ses sous folder
            gestionFermeture(folderId){
                this.$root.$emit('gestionFermeture',folderId) 
            },
            gestionFermetureListe(folderId){
                this.$root.$emit('gestionFermetureListe',folderId) 
            },
            //methode pour la gestion d'extention de l'affichage des sous-folder  lorsque l'on ouvre/ferme  le folder courant
            sendEtendre(folderId ,documentfolderId) {    
                if (this.etendreTab[folderId] === null  ) {
                    this.etendreTab[folderId] = false;         
                }
                this.etendreTab[folderId] = !this.etendreTab[folderId];   
                if(this.etendreTab[folderId] == false){
                    this.gestionFermeture(folderId)
                    this.gestionFermetureListe(documentfolderId)    
                }
                else {
                    this.gestionFermetureListe(folderId)    
                    if(this.estDansLaListe(this.filtrerFolderALaRacine(documentfolderId),folderId)){
                        this.listeFolderAlaRacine.forEach(element => {         
                            if(element != folderId){
                                this.etendreTab[element] = false
                                this.gestionFermeture(element)    
                            }                                   
                        })
                    }                      
                }          
                
                
                   
            },
            //methode qui renvoie true si le folder courant possède des sous-folders
            folderFilsExiste(folderId){
                let i = 0;
                while((i < this.arborescence.length)&& !(this.arborescence[i].document_folder  == folderId)){
                     i++
                }
                if(i < this.arborescence.length){
                    return true
                }
                return false 
            },
            //methode qui renvoie true si le folder courant possède une liste de document
            listeDocumentExiste(folderId){
                
                if(this.listeDocument[folderId] != null){
                    return true
                }
                return false

            },
            //methode pour afficher le statut courant d'un folder 
            afficherStatut(folder) {
                let statut = "";
                switch (folder.document_folder_statut) {
                    case "INC":
                        statut = "Incomplet";
                        break;
                    case "COV":
                        statut = "Complet(validé)";
                        break;
                    case "CAV":
                        statut = "Complet(à vérifier)";
                        break;
                    default:
                        statut = "";
                        break;
                }
                return statut;
            }
        },  
    }
</script>
    
<style lang="scss" scoped>
    @import "../../assets/scss/colors";
    
    
    .cadre {
        padding: 0;
        border: none !important;
        height: 100% !important;     
    }
    
    .fa-folder-open:before {
        margin-right: 8px;
        font-weight: bold;
        content: "\F07C";
    }
    
    .fa-folder-close:before {
        margin-right: 8px;
        content: "\f07b ";
    }

    .fa-arrow:before {
        content: "\f35b";
    }

    /* Tree structure */
    .tree {
        min-height: 20px;
        padding: 0;
        margin: 0;
        background-color: transparent;
        border-radius: 0;
        box-shadow: none;
    }
    
    .tree li {
        list-style-type: none;
        margin: 0;
        padding: 0;
        position: relative;
    }
    
    .tree li::before, .tree li::after {
        display: none;
    }
    
    /* Folder item */
    .menu-brique {
        margin-bottom: 10px;
        
        &.list {
            background-color: #F8F9FB;
            border-radius: 4px;
            border-left: 4px solid #E946A8;
            overflow: hidden;
            transition: all 0.2s ease;
            margin-bottom: 10px;
            box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05);
            
            &:hover {
                box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
            }
        }
    }
    
    /* Folder header/label */
    .a {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 16px;
        border-radius: 0;
        box-shadow: none;
        cursor: pointer;
        transition: background-color 0.2s ease;
        text-decoration: none;
        color: #333;
        font-size: 15px;
        
        > div:first-child {
            display: flex;
            align-items: center;
            font-weight: 600;
            flex: 1;
            min-width: 0;
            gap: 10px;
        }
        
        &:hover {
            background-color: #F5F5F5;
        }
    }
    
    
    /* Status badge */
    .status-badge {
        display: inline-block;
        padding: 6px 12px;
        border-radius: 20px;
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.3px;
        transition: all 0.2s ease;
        white-space: nowrap;
        margin-left: auto;
    }
    
    .badge-incomplete {
        background-color: #FFE5E8;
        color: #C41E3A;
    }
    
    .badge-pending {
        background-color: #FFF4E6;
        color: #E67E22;
    }
    
    .badge-complete {
        background-color: #E8F8F5;
        color: #27AE60;
    }
    
    /* Expanded content wrapper */
    .folder-content-wrapper {
        display: block;
        overflow: hidden;
        transition: max-height 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        max-height: 10000px;
        background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
    }
    
    .folder-content-wrapper[style*="display: none"],
    [v-show="false"] {
        max-height: 0;
    }

    .folder-content {
        overflow: hidden;
    }

    .list-move, 
    .list-enter-active,
    .list-leave-active {
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .list-enter-from,
    .list-leave-to {
        opacity: 0;
        transform: translateX(-15px);
    }

    .list-leave-active {
        position: absolute;
    }

    /* Responsive adjustments */
    @media (max-width: 768px) {
        .margin {
            margin-bottom: 15px;
        }
        
        .a {
            padding: 12px 12px;
            font-size: 14px;
            flex-wrap: wrap;
            gap: 10px;
            
            > div:first-child {
                flex: 0 0 100%;
            }
        }
        
        .status-badge {
            flex: 0 0 auto;
            margin-left: 0;
            font-size: 11px;
            padding: 4px 10px;
        }
    }
    
</style>
    